<template>
  <div v-if="testimonial" class="testimonial-item">
    <div class="testimonial-quote">
      <blockquote>{{testimonial.quote}}</blockquote>
    </div>
    <div class="testimonial-user">
      <div class="testimonial-user-thumb">
        <img class="rounded-circle" :src="imgSrc" alt="" />
      </div>
      <div class="testimonial-user-info">
        <div class="testimonial-user-name">{{testimonial.user}}</div>
        <small class="testimonial-user-date">{{testimonial.date}}</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    testimonial: {
      required: true,
      type: Object
    }
  },

  computed: {
    imgSrc () {
      return require('../assets/img/thumb/' + this.testimonial.img)
    }
  }
}
</script>

<style lang="scss">
@import "../assets/scss/beach-built/imports";

$border-size: 2px;
$quote-border-color: #d4d4d4;
$quote-border-radius: 20px;
$quote-tail-size: 12px;
$quote-tail-x-axis: 165px;
$thumb-border-color: #d4d4d4;

.testimonial-item {
  margin: 30px 0 50px 0;

  .testimonial-quote {
    padding: 1rem;
    margin: 0;
    position: relative;
    background: $white;
    border-radius: $quote-border-radius;
    border: $border-size solid $quote-border-color;
    // background: rgb(19, 55, 186);
    // background: linear-gradient(0deg,rgba(19,55,186,1) 40px, rgba(19,55,186,0) 40px);

    &:before,
    &:after {
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      top: 100%;
    }

    &:before {
      border-left: ($quote-tail-size + $border-size - 10 - 1) solid transparent;
      border-right: ($quote-tail-size + $border-size + 1) solid transparent;
      border-top: ($quote-tail-size + $border-size) solid $quote-border-color;
      left: $quote-tail-x-axis - $border-size;
    }

    &:after {
      border-left: ($quote-tail-size - 10) solid transparent;
      border-right: ($quote-tail-size) solid transparent;
      border-top: ($quote-tail-size) solid $white;
      left: $quote-tail-x-axis;
    }

    blockquote {
      &:last-child {
        margin: 0;
        padding-bottom: 30px;
      }
    }
  }

  .testimonial-user {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin: -35px 20px 0 20px;
  }

  .testimonial-user-thumb {
    width: 90px;
    margin: 0 3px 0 0;
    border-radius: 50%;
    border: 5px solid $white;
    z-index: 1;

    img {
      width: 100%;
      height: auto;
      border: 2px solid $thumb-border-color;
    }
  }

  .testimonial-user-info {
    line-height: 1.1;
    align-self: flex-end;
  }
  .testimonial-user-name {
    font-weight: bold;
  }

  @include media-breakpoint-up(md) {
    .testimonial-quote {
      padding: 2rem 2rem;

      blockquote {
        &:last-child {
          padding-bottom: 50px;
        }
      }
    }

    .testimonial-user {
      margin: -65px 20px 0 20px;
    }

    .testimonial-user-thumb {
      width: 130px;
    }

    .testimonial-user-info {
      margin-bottom: 10px;
    }
  }

  @include media-breakpoint-up(lg) {
    @include make-col-ready();
    @include make-col(6);
  }
}

.testimonials-list {
  @include media-breakpoint-up(lg) {
    @include make-row();
  }
}
</style>
